import { useCallback, useMemo } from 'react';
import type { AcceptInviteRequest, Invite, InviteResponse } from './types';
import { useService } from '../common';

const API = {
    INVITE: '/user/invite'
};

export const useInviteService = () => {
    const service = useService();
    const getInvite = useCallback((inviteId: string): Promise<Invite> => {
        return service.sendGetWithoutAuthorization(`${API.INVITE}?inviteId=${inviteId}`)
            .then(service.handleResponse)
    }, [service]);
    const acceptInvite = useCallback((request: AcceptInviteRequest): Promise<InviteResponse> => {
        return service.sendPostWithoutAuthorization(API.INVITE, request)
            .then(service.handleResponse);
    }, [service]);
    return useMemo(() => ({
        getInvite,
        acceptInvite
    }), [getInvite, acceptInvite]);
};
